import UpgradePlanModal from '@/components/Modals/UpgradePlanModal';
import { pricingStudioUrl } from '@/environment';
import voicePremiumUpgrade from '@/images/upgrades/voicePremiumUpgrade.svg';
import Volume from '@/images/Volume.svg';
import { useAnalytics } from '@/services/analytics';
import styled from '@emotion/styled';
import { Icon, Link } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { InlineToast } from './InlineToast';

const PRICING_QUERY_PARAM_SOURCE = 'studio-tts';

const StyledInlineToast = styled(InlineToast)`
    background-color: ${({ theme }) => theme.colors.primary.bg};
    padding-right: 10px;
    border-radius: 8px;
`;

const UpgradeLink = styled(Link)`
    color: ${({ theme }) => theme.colors.primary.main};
    cursor: pointer;
    font-weight: 700;
`;

const SpeakerIcon = styled(Icon)`
    height: 2rem !important;
    width: 2rem;
    margin: 1rem 1rem 0;
`;

const ListenImage = styled.img`
    height: 2rem;
    width: 2rem;
`;

interface Props {
    show: boolean;
    maxWords: number;
}

export const WordLimitsInlineToast = ({ show, maxWords }: Props) => {
    const mixpanel = useAnalytics();
    const [showUpgradeModal, setShowUpgradeModal] = useState(false);

    const upgradeClick = useCallback(() => {
        mixpanel?.track('upgrade', {
            from: 'tts-preview',
            event: 'click',
        });

        // setShowUpgradeModal(true);
        window.open(`${pricingStudioUrl}/?utm_source=${PRICING_QUERY_PARAM_SOURCE}`);
    }, [mixpanel]);

    useEffect(() => {
        if (show) {
            mixpanel?.track('upgrade', {
                from: 'tts-preview',
                event: 'view',
            });
        }
    }, [show]);

    return (
        <StyledInlineToast
            show={show}
            icon={
                <SpeakerIcon>
                    <ListenImage src={Volume} />
                </SpeakerIcon>
            }
            title={`${maxWords} words preview limit exceeded`}
            content={
                <>
                    <UpgradeLink onClick={upgradeClick}>Upgrade</UpgradeLink> to a paid plan to get full script preview access
                    <UpgradePlanModal
                        open={showUpgradeModal}
                        onClose={() => setShowUpgradeModal(false)}
                        title={<div>Upgrade your plan to preview your entire script</div>}
                        imageFile={voicePremiumUpgrade}
                        from="tts-preview"
                    />
                </>
            }
        />
    );
};
